import FactoryIcon from "@mui/icons-material/Factory";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "production", spoke: "production", title: "Production", icon: FactoryIcon, order: 44, entries: [
  { label: "Dashboard", to: "/app/production/dashboard", permission: "production.work_order.view" },
  { label: "Work orders", to: "/app/production/work-orders", permission: "production.work_order.view" },
  { label: "Dispatch list", to: "/app/production/dispatch", permission: "production.execution.view" },
  { label: "Shop floor kiosk", to: "/app/production/kiosk", permission: "production.execution.operate" },
  { label: "Outside processing & WIP", to: "/app/production/outside", permission: "production.material.view" },
] });
